import { render, staticRenderFns } from "./ResumoContrato.vue?vue&type=template&id=466e9010&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ResumoContrato.vue?vue&type=script&lang=js&"
export * from "./ResumoContrato.vue?vue&type=script&lang=js&"
import style0 from "./ResumoContrato.vue?vue&type=style&index=0&id=466e9010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466e9010",
  null
  
)

export default component.exports